export default __webpack_public_path__ + "static/media/01AW3JUL66.55d52c1c.jpg";